const { request } = require('axios')

/**
 * スプレッドシートをJSONで取ってくる
 * @see https://developers.google.com/sheets/api/reference/rest/v4/spreadsheets.values/get
 * @param {string} publishedSheetId シートの公開ID
 * @returns {object} entries JSONオブジェクト
 */
const requestSheetAsJson = async publishedSheetId =>
  request({
    method: 'GET',
    url: `https://sheets.googleapis.com/v4/spreadsheets/${publishedSheetId}/values/A:Z?alt=json&key=__GCP_API_KEY__`,
  }).then(response => response.data.values)
    // 行列セルの配列をJSON配列に変換する
    //  先頭行はJSONのキーとして扱う
    .then(([keys, ...rows]) => rows.map(
      // 各行をJSONオブジェクトにする
      row => row.reduce((acc, current, index) => {
        acc[keys[index]] = current
        return acc
      }, {}),
    ))

module.exports = requestSheetAsJson
